import { SdkAcdAgent } from '../sdk-acd/sdk-acd.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { Injectable } from '@angular/core';
import { CXonePopUrl } from '@nice-devone/common-sdk';
import { CxOneUtils } from '../util/CxOneUtils';
import {} from '@nice-devone/agent-sdk';
import {
  DigitalSessionDirection,
  DigitalSessionEndReason,
  DigitalSessionEventDTO,
  DigitalSessionEventType,
} from 'src/app/components/pessoa-fisica/domain/ContactCenter/DigitalSessionEventDTO';
import { SdkDigitalService } from '../sdk-digital/sdk-digital.service';
import {
  CXoneDigitalClient,
  CXoneDigitalContact,
} from '@nice-devone/digital-sdk';
import { Subject } from 'rxjs';
import { IContactCenterDigital } from 'src/app/components/seguros-pf/interfaces/IContactCenterDigital';
import { TicketCreationRequestControlService } from 'src/app/shared/services/ticket-creation-request-control.service';
import { quickWebLogger } from '@quickweb/logger';
import { getUserIfoInLocalStorage } from 'src/app/utils/get-user-info-In-localstorage';
import { CIFDatadogService } from 'src/app/shared/services/cif-datadog';
import {
  extractPopUrlMediaType,
  getMediaType,
} from 'src/app/utils/cxone-utils';
import { JsonConverterUtils } from '../util/JsonConverterUtils';
import { SessionStorageUtils } from '../util/SessionStorageUtils';

@Injectable({
  providedIn: 'root',
})
export class ContactCenterConsultoresPFService
  implements IContactCenterDigital
{
  public onDigitalSessionEvent$ = new Subject<DigitalSessionEventDTO>();
  public onFocusEvent$ = new Subject<CXonePopUrl>();
  public onAttachedEvent$ = new Subject<CXonePopUrl>();
  private pendingPopUrls = new Map<string, CXonePopUrl>();

  constructor(
    private sdkAcdAgent: SdkAcdAgent,
    private logger: LoggerService,
    private sdkDigital: SdkDigitalService,
    private ticketCreationRequestControlService: TicketCreationRequestControlService,
    private cifDatadogService: CIFDatadogService,
    private jsonConverterUtils: JsonConverterUtils,
    private sessionStorageUtils: SessionStorageUtils,
  ) {}

  public async initializer() {
    try {
      await this.sdkDigital.initializeEvents();
      CXoneDigitalClient.instance.digitalContactManager.onDigitalContactEvent.subscribe(
        async (digitalContact: CXoneDigitalContact) => {
          this.DigitalContactHandler(digitalContact);
        },
      );
      this.sdkAcdAgent.instance.screenPop.screenPopSubscribe(
        true,
        true,
        true,
        true,
        true,
        true,
      );
      this.sdkAcdAgent.instance.screenPop.popUrlSubject.subscribe(
        (popUrlData: CXonePopUrl) => {
          this.PopUrlHandler(popUrlData);
        },
      );
    } catch (error) {
      this.logger.warn('Falha inicialização de digital:', error);
    }
  }

  private async DigitalContactHandler(digitalContact: CXoneDigitalContact) {
    this.logger.info('Digital contact recebido: ', digitalContact);

    if (digitalContact.eventDetails.eventType === 'CaseInboxAssigned') {
      this.DigitalContactCaseAssignedHandler(digitalContact);
    }

    if (digitalContact.eventDetails.eventType === 'CaseInboxUnassigned') {
      this.DigitalContactCaseUnassignedHandler(digitalContact);
    }
  }

  private DigitalContactCaseAssignedHandler(
    digitalContact: CXoneDigitalContact,
  ) {
    const popUrl =
      this.pendingPopUrls.get(digitalContact.caseId) ??
      this.logger.warn(
        'PopUrl não encontrado para o contato digital: ',
        digitalContact.caseId,
      );

    const attachData = CxOneUtils.CreateDictionaryFromPopUrl(popUrl?.url) ?? {};

    const digitalSession: DigitalSessionEventDTO = {
      Id: digitalContact.caseId,
      AttachData: attachData,
      SessionDirection: DigitalSessionDirection.Inbound,
      SessionEventType: DigitalSessionEventType.Assigned,
      mediaType: getMediaType(digitalContact),
    };
    this.onDigitalSessionEvent$.next(digitalSession);
  }

  private DigitalContactCaseUnassignedHandler(
    digitalContact: CXoneDigitalContact,
  ) {
    let digitalSession: DigitalSessionEventDTO = {
      Id: digitalContact.caseId,
      SessionDirection: DigitalSessionDirection.Inbound,
      SessionEventType: DigitalSessionEventType.Unassigned,
      SessionEndReason: DigitalSessionEndReason.Closed,
      mediaType: getMediaType(digitalContact),
    };
    this.onDigitalSessionEvent$.next(digitalSession);
    return;
  }
  private async PopUrlHandler(popUrl: CXonePopUrl) {
    this.logger.info('PopUrl recebido:', popUrl);
    const user = getUserIfoInLocalStorage();

    if (popUrl.tabTitle?.toUpperCase() === 'ATTACHESDYNAMICS') {
      // quando os dados chegann da nice
      quickWebLogger.logger.info(
        'Informações de solicitação de lead enviado pelo evento ATTACHESDYNAMICS (PopupUrl).',
        {
          details: {
            user,
            interactionId: popUrl.contactId,
            attachData: popUrl.url,
          },
        },
      );

      const ticketExists =
        this.ticketCreationRequestControlService.checkTicketRequest(
          popUrl.contactId,
        );

      if (ticketExists === true) {
        this.cifDatadogService.openTicket.request.duplicated({
          masterId: popUrl.contactId,
          attachData: popUrl.url,
          mediaType: extractPopUrlMediaType(popUrl),
        });
        return;
      }

      this.ticketCreationRequestControlService.saveTicketRequest(
        popUrl.contactId,
      );
      this.pendingPopUrls.set(popUrl.contactId, popUrl);
      this.logger.info(
        'Attachdata amazenado para contato digital: ',
        popUrl.contactId,
      );
      this.ticketCreationRequestControlService.clearUpLastTicketCreationRequest();
      this.onAttachedEvent$.next(popUrl);
    }

    if (popUrl.tabTitle?.toUpperCase() === 'FOCUS') {
      quickWebLogger.logger.info(
        'Informações de solicitação de lead enviado pelo evento FOCUS (PopupUrl) ',
        {
          details: {
            user,
            interactionId: popUrl.contactId,
            attachData: popUrl.url,
          },
        },
      );

      this.pendingPopUrls.set(popUrl.contactId, popUrl);

      this.onFocusEvent$.next(popUrl);
    }
  }

  public formatNiceDataToDynamcis(event: CXonePopUrl) {
    try {
      const attachData: {
        U_JSON: string;
      } = CxOneUtils.CreateDictionaryFromPopUrl(event.url);

      const u_json_parsed: Record<string, unknown> =
        this.jsonConverterUtils.JsonParsed(attachData.U_JSON);
      const u_json_with_contactId = {
        ...u_json_parsed,
        NICE_CONTACT_ID: event.contactId,
      };

      const createRecordObject = {
        u_json: u_json_with_contactId,
      };

      return createRecordObject;
    } catch (error: unknown) {
      const user = getUserIfoInLocalStorage();
      quickWebLogger.logger.error(
        'Falha ao formatar dados do NICE para o Dynamics',
        {
          details: {
            user,
            interactionId: event.contactId,
            error,
            attachData: event.url,
          },
        },
      );
      return null;
    }
  }
}
